/* cb-currency-fix.js v8 — Kronor-markten (SEK/DKK) + euro-notatie per taal.
   (1) SEK/DKK-sessie: euro-bedragen → juiste kronen (store-koers, net afgerond, " kr").
   (2) EUR-sessie op een taal die het euroteken ACHTER het bedrag schrijft (fi; evt. de/fr/it):
       "€2,75" → "2,75 €" (met vaste spatie). Alleen symboolplaatsing, bedrag blijft gelijk.
   Koers: SEK 11,4 · DKK 7,46. */
(function () {
  'use strict';
  var RATES = { SEK: 11.4, DKK: 7.46 };
  var RATE = 0;
  /* Talen die het euroteken NA het bedrag willen (continentale conventie: "2,75 €").
     fi/de/fr/it schrijven het teken erna; nl/en houden het ervóór; sv/da gebruiken kr → n.v.t. */
  var EURO_AFTER = { fi: 1, de: 1, fr: 1, it: 1 };
  function active(){ return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; }
  function locale(){
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.getAttribute('lang') || '';
    return l.toLowerCase().slice(0, 2);
  }

  var PRICE_SEL = '.price, .price-item, .money, .pdpb-bopt__price, .pdpb-bopt__save, .cb-gs, .cb-vp, .cb-bp__product-price, .cb-bp__qty-line-total, [data-box-price], [data-line-total]';
  var SKIP = { SCRIPT:1, STYLE:1, NOSCRIPT:1, TEXTAREA:1, SELECT:1, OPTION:1, CODE:1, PRE:1, INPUT:1 };

  function fmt(kr){
    var r;
    if (kr < 100) r = Math.round(kr/5)*5;
    else if (kr < 1000) r = Math.round(kr/10)*10;
    else r = Math.round(kr/50)*50;
    var s = String(r);
    if (r >= 1000) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + ' kr';
  }
  function parseEur(num){
    var s = num.replace(/[^\d.,]/g, '');
    if (s.indexOf(',') >= 0) { s = s.replace(/\./g, '').replace(',', '.'); }
    else { var m = s.match(/^(\d+)\.(\d+)$/); if (m) { s = (m[2].length === 3) ? (m[1]+m[2]) : (m[1]+'.'+m[2]); } }
    var f = parseFloat(s);
    return isNaN(f) ? null : f;
  }

  var SYM_RE = /€\s*(\d[\d.]*,\d{2}|\d[\d.]*\d|\d)/g;
  function sym(n){ var t = n.nodeValue; var nt = t.replace(SYM_RE, '$1 kr'); if (nt !== t) n.nodeValue = nt; }

  var EUR_RE = /€\s*(\d[\d.,]*\d|\d)/g;
  function rate(n){
    var t = n.nodeValue;
    var nt = t.replace(EUR_RE, function(m, num){ var e = parseEur(num); return (e === null) ? m : fmt(e*RATE); });
    if (nt !== t) n.nodeValue = nt;
  }

  /* euro-teken naar achter: "€2,75" → "2,75 €" (vaste spatie). Idempotent + magnitude-behoudend. */
  var AFTER_RE = /€ ?\s?(\d[\d.,]*\d|\d)/g;
  function euroAfter(n){
    var t = n.nodeValue;
    if (t.indexOf('€') < 0) return;
    var nt = t.replace(AFTER_RE, '$1 €');
    if (nt !== t) n.nodeValue = nt;
  }

  function walk(root, fn, skipPrice){
    if (!root) return;
    try {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function(n){
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.isContentEditable) return NodeFilter.FILTER_REJECT;
        if (!n.nodeValue || n.nodeValue.indexOf('€') < 0) return NodeFilter.FILTER_REJECT;
        if (skipPrice && p.closest && p.closest(PRICE_SEL)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }});
      var arr = [], n;
      while (n = w.nextNode()) arr.push(n);
      for (var i = 0; i < arr.length; i++) fn(arr[i]);
    } catch (e) {}
  }

  /* B2B-verzending: copy zegt €10 (NL-tarief), echte SE/DK-B2B = €15. Toon in de juiste kronen. */
  function fixB2BShip(){
    try {
      var ship = fmt(15 * RATE), free = fmt(500 * RATE);
      var els = document.querySelectorAll('.cb-bp__pricing-note');
      for (var i = 0; i < els.length; i++) {
        var el = els[i], h = el.innerHTML;
        var nh = h.replace(/Frakt[^.<]*gratis från[^.<]*/, 'Frakt ' + ship + ', gratis från ' + free)
                  .replace(/Fragt[^.<]*gratis fra[^.<]*/, 'Fragt ' + ship + ', gratis fra ' + free);
        if (nh !== h) el.innerHTML = nh;
      }
    } catch (e) {}
  }

  function run(){
    RATE = RATES[active()] || 0;
    if (RATE) {
      var els = document.querySelectorAll(PRICE_SEL);
      for (var i = 0; i < els.length; i++) walk(els[i], sym, false);
      walk(document.body, rate, true);
      fixB2BShip();
      return;
    }
    /* Geen kronen-sessie → euro. Op talen met "bedrag €"-conventie het symbool verplaatsen. */
    if (EURO_AFTER[locale()]) walk(document.body, euroAfter, false);
  }
  function boot(){
    run();
    ['cart:refresh','cart:updated','cb:cart-updated'].forEach(function(e){ document.addEventListener(e, function(){ setTimeout(run, 150); }); });
    if (window.MutationObserver) {
      var pending = false;
      var mo = new MutationObserver(function(){ if (pending) return; pending = true; setTimeout(function(){ pending = false; run(); }, 250); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
